/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type changeJiraRemainingSyncInput = {|
  forecastProjectId?: ?string,
  syncRemaining?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ChangeJiraRemainingSyncMutationVariables = {|
  input: changeJiraRemainingSyncInput
|};
export type ChangeJiraRemainingSyncMutationResponse = {|
  +changeJiraRemainingSync: ?{|
    +project: ?{|
      +remainingAutoCalculated: ?boolean,
      +jiraSyncRemaining: ?boolean,
      +jiraCloudProjectSettings: ?{|
        +isSyncDone: ?boolean
      |},
    |}
  |}
|};
export type ChangeJiraRemainingSyncMutation = {|
  variables: ChangeJiraRemainingSyncMutationVariables,
  response: ChangeJiraRemainingSyncMutationResponse,
|};
*/


/*
mutation ChangeJiraRemainingSyncMutation(
  $input: changeJiraRemainingSyncInput!
) {
  changeJiraRemainingSync(input: $input) {
    project {
      remainingAutoCalculated
      jiraSyncRemaining
      jiraCloudProjectSettings {
        isSyncDone
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "changeJiraRemainingSyncInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraSyncRemaining",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSyncDone",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeJiraRemainingSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "changeJiraRemainingSyncPayload",
        "kind": "LinkedField",
        "name": "changeJiraRemainingSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeJiraRemainingSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "changeJiraRemainingSyncPayload",
        "kind": "LinkedField",
        "name": "changeJiraRemainingSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectSettingsType",
                "kind": "LinkedField",
                "name": "jiraCloudProjectSettings",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ChangeJiraRemainingSyncMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeJiraRemainingSyncMutation(\n  $input: changeJiraRemainingSyncInput!\n) {\n  changeJiraRemainingSync(input: $input) {\n    project {\n      remainingAutoCalculated\n      jiraSyncRemaining\n      jiraCloudProjectSettings {\n        isSyncDone\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f66cf54193cca593883fa9c85993b6a';

module.exports = node;
